import { TRADABLES_TYPE } from "@helpers/constants";
import { Metal as OldMetal } from "@models/asset/metal/metal";
import { Tradable, TradableAdapter } from "../tradable";

export interface Metal extends Tradable {
	measurementUnit: string;
}

export class MetalAdapter extends TradableAdapter {
	public adapt(metal: OldMetal): Metal {
		const tradable = super.adapt(metal);
		return {
			...tradable,
			measurementUnit: metal.getSymbol(),
			type: TRADABLES_TYPE.METAL
		};
	}
}
